import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Space, Table, Typography } from 'antd';

import { Link } from 'react-router-dom';
import { ContentWrapper } from '@/components/_common';
import { useWorkOrders } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { ColumnsType } from '@/components/_common/InfiniteTable';
import { ListWorkOrdersResult } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { COLUMNS_WIDTH, getTableScrollX } from '@/utils/table';
import EditIcon from '@/components/_common/EditIcon';
import StatusTag from '@/components/_common/StatusTag';
import {
  workorderComplementColor,
  WorkOrderComplementStatus,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';

const { Title } = Typography;

function HomeWorkOrders() {
  const intl = useIntl();
  const { data, isFetching } = useWorkOrders({ rows: 6, order: 1 });

  const workOrders = flatInfiniteData(data);

  const columns: ColumnsType<ListWorkOrdersResult> = [
    { dataIndex: 'complementIdentifier', width: COLUMNS_WIDTH.default },
    {
      dataIndex: ['licensePlate'],
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      dataIndex: ['company', 'name'],
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      dataIndex: ['estimator', 'name'],
      width: COLUMNS_WIDTH.default,
      ellipsis: true,
    },
    {
      dataIndex: 'status',
      render: (value: WorkOrderComplementStatus) => (
        <StatusTag
          color={workorderComplementColor[value]}
          label={intl.formatMessage({ id: `workOrders.${value}` })}
        />
      ),
      width: 100,
    },
    {
      dataIndex: 'actions',
      width: 50,
      fixed: 'right',
      align: 'right',
      render: (_, record) => (
        <EditIcon
          redirect={`/app/movements/workOrders/${record.workOrderId}/complements/${record.complementId}/generalInfo`}
        />
      ),
    },
  ];

  return (
    <ContentWrapper
      style={{
        height: '360px',
        padding: 24,
      }}
    >
      <Space size="large">
        <Title level={4} style={{ margin: 0 }}>
          <FormattedMessage id="workOrders" />
        </Title>
        <Link to="/app/movements/workOrders/">
          <Button type="link">
            <FormattedMessage id="commons.entity.viewAll" />
          </Button>
        </Link>
      </Space>

      <div style={{ overflowX: 'auto', height: '100%' }}>
        <Table<ListWorkOrdersResult>
          columns={columns}
          dataSource={workOrders}
          loading={isFetching}
          rowKey={(row) => row.complementId}
          scroll={{ x: getTableScrollX(columns) }}
          footer={undefined}
          pagination={false}
        />
      </div>
    </ContentWrapper>
  );
}

export default HomeWorkOrders;
